import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';
import { getBlogPosts } from '@/api/blog.js'

async function getRegistrationRequests() {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Administration/GetRegistrationRequests',
  });
  return data;
}

async function rejectRegistrationRequest({ requestId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Administration/RejectRegistrationRequest',
    data: sanitizePostData({
      requestId,
    }),
  });
  return data;
}

async function acceptRegistrationRequest({ requestId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Administration/AcceptRegistrationRequest',
    data: sanitizePostData({
      requestId,
    }),
  });
  return data;
}

async function getCompanyBlogposts(skip, limit) {
  return await getBlogPosts('Company', 0, 'Public', null, null, skip, limit);
}

export {
  getRegistrationRequests,
  rejectRegistrationRequest,
  acceptRegistrationRequest,
  getCompanyBlogposts
};
